export const FORM_CODE_FF017 = 'FF017';

export type YesNo = 'yes' | 'no';

export type SiteArrivalConfirmationFormValues = {
  travelReceiptAcknowledged?: YesNo | '';
  healthCheckupDate?: string;
  healthCheckupLocation?: string;
  companyAccommodation?: YesNo | '';
  rentTv?: YesNo | '';
  rentFuton?: YesNo | '';
  rentFridge?: YesNo | '';
  rentOther?: string;
  agreeDorm?: 'true' | 'false' | '';
  breakfast?: YesNo | '';
  lunch?: YesNo | '';
  dinner?: YesNo | '';
  agreeMeal?: 'true' | 'false' | '';
  consentDateFf017?: string;
};

export type SiteArrivalConfirmationStep =
  | 'travelReceiptAcknowledged'
  | 'healthCheckupDate'
  | 'healthCheckupLocation'
  | 'companyAccommodation'
  | 'rentTv'
  | 'rentFutons'
  | 'rentFridge'
  | 'rentOther'
  | 'agreeDorm'
  | 'breakfast'
  | 'lunch'
  | 'dinner'
  | 'agreeMeal';
